/**
 * How a locker row preview starts.
 *
 * A flagged extraction uses the same acknowledgement gate as every other
 * preview. The forensic viewer opens only after that ack, or immediately when
 * the file is not flagged.
 */
export function lockerPreviewStep(
  isUfdrRoot: boolean,
  cmType: string | null | undefined,
): { step: 'acknowledge'; opensUfdrAfterAck: boolean } | { step: 'ufdr' } | { step: 'other' } {
  if (cmType) return { step: 'acknowledge', opensUfdrAfterAck: isUfdrRoot };
  if (isUfdrRoot) return { step: 'ufdr' };
  return { step: 'other' };
}
